import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CourseType } from '@cna/projects/ak-jura/shared/interfaces';
import { Store } from '@ngrx/store';
import { skipWhile, take, withLatestFrom } from 'rxjs/operators';
import {
    selectCourseParticipationObjectForSelectedNew
} from '../../../../../../../../../apps/ak-jura/frontends/my-ak-jura/src/app/+state/course/selectors';
import {
    selectCustomer
} from '../../../../../../../../../apps/ak-jura/frontends/my-ak-jura/src/app/+state/customer/selectors';
import {
    MeinAkJuraEnvironment
} from '../../../../../../../../../apps/ak-jura/frontends/my-ak-jura/src/environments/environment.interface';
import { EnvironmentService } from '../../../../../../../../angular/services/src/lib/environment/environment.service';
import {
    ControlTestEvidence
} from '../../../../../../shared/interfaces/src/lib/data-management/control-test/control-test-evidence';
import { LearningModuleDocumentInfo } from '../../../../../../shared/interfaces/src/lib/learning-module-document-info';
import { PdfCreatorService } from '../../../../../file-creation/src/lib/pdf-creator.service';

@Injectable()
export class CertificateService {
    private get environment(): MeinAkJuraEnvironment {
        return this.environmentService.getEnvironment();
    }

    constructor(
        private store: Store,
        private pdfCreatorService: PdfCreatorService,
        private http: HttpClient,
        private environmentService: EnvironmentService
    ) {}

    async downloadLearnControlPdf(
        moduleInfo: LearningModuleDocumentInfo,
        courseType: CourseType
    ) {
        this.store
            .select(selectCourseParticipationObjectForSelectedNew)
            .pipe(
                withLatestFrom(this.store.select(selectCustomer)),
                skipWhile(id => !id),
                take(1)
            )
            .subscribe(([courseParticipation, customer]) => {
                this.http
                    .get(
                        `${this.environment.apiHost}/customer/me/${moduleInfo.controlTestCourseParticipationId}/control-test-evidence/${moduleInfo.controlTestId}`
                    )
                    .subscribe(
                        async (controlTestEvidence: ControlTestEvidence) => {
                            if (courseType === CourseType.EducationCourse) {
                                this.pdfCreatorService.createLearnControlPdf(
                                    customer,
                                    courseParticipation,
                                    moduleInfo,
                                    controlTestEvidence
                                );
                            } else if (
                                courseType === CourseType.TrainingCourse
                            ) {
                                await this.pdfCreatorService.createTrainingCourseCertificate(
                                    customer.displayName,
                                    {
                                        ...courseParticipation,
                                        controlTestEvidence,
                                    }
                                );
                            }
                        }
                    );
            });
    }
}
